<template>
  <div class="container px-2 md:px-0 mx-auto space-y-2">
    <div class="md:flex md:justify-between md:space-x-2 py-6">
      <div class="md:w-1/3 pb-4">
        <h3 class="text-xl">Профиль</h3>
        <p class="mt-1 text-sm text-gray-600">
          Обновите информацию профиля и адрес электронной почты вашей учетной записи.
        </p>
      </div>
      <profile-update class="md:w-2/3 p-4 bg-white shadow-md rounded-lg"></profile-update>
    </div>

    <div class="md:flex md:justify-between md:space-x-2 py-6">
      <div class="md:w-1/3 pb-4">
        <h3 class="text-xl">Пароль</h3>
        <p class="mt-1 text-sm text-gray-600">
          Убедитесь, что ваша учетная запись использует длинный и случайный пароль для обеспечения безопасности.
        </p>
      </div>
      <password-update class="md:w-2/3 p-4 bg-white shadow-md rounded-lg"></password-update>
    </div>

    <div class="md:flex md:justify-between md:space-x-2 py-6">
      <div class="md:w-1/3 pb-4">
        <h3 class="text-xl">ПИН-код</h3>
        <p class="mt-1 text-sm text-gray-600">
          Обновите ПИН-код для быстрого входа в систему. ПИН-код должен состоять из 4-х цифр.
        </p>
      </div>
      <pin-code-update class="md:w-2/3 p-4 bg-white shadow-md rounded-lg"></pin-code-update>
    </div>

    <div class="md:flex md:justify-between md:space-x-2 py-6" v-if="false">
      <div class="md:w-1/3 pb-4">
        <h3 class="text-xl">Двухфакторная аутентификация</h3>
        <p class="mt-1 text-sm text-gray-600">
          Добавьте дополнительную безопасность к вашей учетной записи с помощью двухфакторной аутентификации.
        </p>
      </div>
      <two-factore-authentication class="md:w-2/3 p-4 bg-white shadow-md rounded-lg"></two-factore-authentication>
    </div>
  </div>
</template>

<script>
import TwoFactoreAuthentication from '@/components/user/TwoFactoreAuthentication.vue'
import ProfileUpdate from '@/components/user/ProfileUpdate.vue'
import PasswordUpdate from '@/components/user/PasswordUpdate.vue'
import PinCodeUpdate from '@/components/user/PinCodeUpdate.vue'

export default {
  components: {
    TwoFactoreAuthentication,
    ProfileUpdate,
    PasswordUpdate,
    PinCodeUpdate,
  }
}
</script>
